// extracted by mini-css-extract-plugin
module.exports = {"isLoading":"styles_isLoading__ZDpgj","spinnerOut":"styles_spinnerOut__EQIyC","spinnerIn":"styles_spinnerIn__KyJte"};